import React, { InputHTMLAttributes } from 'react';
import styles from './GeneralTable.module.css';

type Props = InputHTMLAttributes<HTMLTableHeaderCellElement>;

function GeneralTableHead({ children, style }: Props) {
  return (
    <th style={style} className={styles.generalTableTh}>
      {children}
    </th>
  );
}

export default GeneralTableHead;
